export enum RoleDTO {
  SYSTEM_ADMIN = "SYSTEM_ADMIN",
  ACCOUNT_ADMIN = "ACCOUNT_ADMIN",
  USER = "USER",
  SUPPORT = "SUPPORT",
}

export const isUserAdmin = (roles: RoleDTO[]): boolean => {
  return (
    roles.includes(RoleDTO.ACCOUNT_ADMIN) ||
    roles.includes(RoleDTO.SYSTEM_ADMIN) ||
    roles.includes(RoleDTO.SUPPORT)
  );
};
